import * as yup from 'yup'
import moment from 'moment'

import helpers from 'helpers'

const isFutureDate = (value) => {
  if (!value) return true

  return moment(value).isAfter(moment(), 'day')
}

const schema = ({ hasBenefits, platformServicePrice }) =>
  yup.object().shape({
    reason: yup.string().when('status', {
      is: 'churn',
      then: yup.string().required(),
    }),
    status: yup.string().required(),
    description: yup.string().max(1000),
    benefits: yup.string().when([], {
      is: () => hasBenefits,
      then: yup.string().required(),
    }),
    gratuity: yup
      .string()
      .max(2)
      .when('benefits', {
        is: 'freeMonthlyFee',
        then: yup.string().max(2).required(),
      }),
    discount: yup.string().when('benefits', {
      is: 'discount',
      then: yup
        .string()
        .required()
        .test(
          'lessThanCurrentPrice',
          'O valor final deve ser menor que o valor atual do serviço',
          (value) => {
            const currentPrice = parseFloat(platformServicePrice)

            if (!currentPrice) return true

            return helpers.formatters.currencyOutput(value) < currentPrice
          },
        ),
    }),
    accessCancellationDate: yup
      .string()
      .nullable()
      .when('status', {
        is: 'churn',
        then: yup
          .string()
          .nullable()
          .required()
          .test('isFutureDate', 'A data deve ser maior que hoje', isFutureDate),
      }),
    contractFinalizationDate: yup
      .string()
      .nullable()
      .when('status', {
        is: 'churn',
        then: yup
          .string()
          .nullable()
          .required()
          .test('isFutureDate', 'A data deve ser maior que hoje', isFutureDate),
      }),
  })

export default schema
